import { SignInPage, SignInProviderConfig } from '@backstage/core-components';
import { SignInPageProps, configApiRef, oktaAuthApiRef, useApi } from '@backstage/core-plugin-api';

const GUEST_ACCESS_ENVS = ['pr', 'sandbox', 'local'];

const oktaProvider: SignInProviderConfig = {
  id: 'okta-auth-provider',
  title: 'Okta',
  message: 'Sign in using Okta',
  apiRef: oktaAuthApiRef,
};

export const CustomSignInPage = (props: SignInPageProps) => {
  const config = useApi(configApiRef);
  const appEnv = config.getOptionalString('app.environment');

  if (appEnv && GUEST_ACCESS_ENVS.includes(appEnv)) {
    return <SignInPage {...props} align="center" providers={['guest', oktaProvider]} />;
  }

  return <SignInPage {...props} provider={oktaProvider} />;
};
